import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { DSRM_Explainer } from "./DSRM_Explainer";
// It's easier, in this case, to keep these values and the padding func in this component.
// They won't be referenced anywhere else in the DSRM and they exist only to prevent magic number mishaps.
export const rowGap = "2.5rem";
export const columnGap = "3.75rem";
const getPadding = (isMobile) => (isMobile ? "1rem 1rem 2.5rem" : "1rem 3.75rem 2rem");
export const DSRM_Content = ({ orderData, orderNumber, currentAddressCardData }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const padding = getPadding(isMobile);
    return (_jsx(Box, Object.assign({ display: "flex", flexDirection: "column", style: { rowGap: rowGap, padding: padding } }, { children: _jsx(DSRM_Explainer, Object.assign({}, { orderNumber, orderData })) })));
};
